import React from 'react'
import { makeStyles } from '@paintscout/ui'
import type { AlbumPhoto } from '@paintscout/util/pexels'
import { distributeToColumns } from '@paintscout/util/pexels'
import PhotoOption from './PhotoOption'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-start'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0
  }
})

export interface PhotoMasonryProps {
  photos: AlbumPhoto[]
  columns: number
  spacing?: number
  /** Multi-select indicator — StockPhotoPanel's single-select flow never sets this. */
  selectedKeys?: Set<string>
}

/**
 * Lightweight, dependency-free masonry grid. Distributes photos into balanced columns by
 * aspect ratio ({@link distributeToColumns}) and lays them out with flexbox — no external
 * masonry library needed.
 */
function PhotoMasonry({ photos, columns, spacing = 8, selectedKeys }: PhotoMasonryProps) {
  const classes = useStyles()
  const cols = distributeToColumns(photos, columns)

  return (
    <div className={classes.root} style={{ gap: spacing }}>
      {cols.map((col, index) => (
        <div key={index} className={classes.column} style={{ gap: spacing }}>
          {col.map((photo) => (
            <PhotoOption key={photo.key} photo={photo} selected={selectedKeys?.has(photo.key)} />
          ))}
        </div>
      ))}
    </div>
  )
}

export default PhotoMasonry
